import { Component, Injector, OnInit, computed, forwardRef, input, model, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DxTagBoxComponent, DxTagBoxModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/tag_box';
import { LayoutControlComponent } from '../../internal/layout-control/layout-control.component';
import { ControlLabelComponent } from '../../internal/control-label/control-label.component';
import { ControlSupportingTextComponent } from '../../internal/control-supporting-text/control-supporting-text.component';

@Component({
  selector: 'app-multiselectbox',
  templateUrl: './multiselectbox.component.html',
  styleUrls: ['./multiselectbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectboxComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LayoutControlComponent, ControlLabelComponent, DxTagBoxModule, ControlSupportingTextComponent]
})
export class MultiselectboxComponent implements OnInit, ControlValueAccessor {
  private dx = viewChild.required<DxTagBoxComponent>('dx');
  private ngControl: NgControl = null;

  caption = input.required<string>();
  helpText = input<string>('');
  value = model<any[]>(null);
  dataSource = input.required<any[]>();
  valueExpr = input<string>('id');
  displayExpr = input<string>(null);

  computedValue = computed(() => this.value() || []);

  constructor(
    private injector: Injector
  ) { }

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl);
  }
  get control(): AbstractControl {
    return this.ngControl?.control;
  }

  get isValid(): boolean {
    return !this.control || (this.control.invalid !== true || (this.control.pristine && this.control.untouched));
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.computedValue()) {
      this.onChanged(e.value);
      this.value.set(e.value);
    }
  }


  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: any): void {
    this.value.set(obj);
  }

  onChanged: (value: any) => void = () => { };
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.dx().disabled = isDisabled;
  }
}
